import React, { memo } from "react";
import PropTypes from "prop-types";

import MatchedPhraseEvent from "./MatchedPhraseEvent";
import RedactedSectionEvent from "./RedactedSectionEvent";
import SpeechEvent from "./SpeechEvent";

const Events = ({ events, progressPercent, position }) => {
  return events.reduce((allEvents, { startTime, endTime, speaker, matchedPhrases, redactedSections }, eventIndex) => {
    if (matchedPhrases && matchedPhrases.length > 0) {
      allEvents.push(matchedPhrases.map((event, matchedPhraseIndex) =>
        <MatchedPhraseEvent key={`matched-phrase-${eventIndex}-${matchedPhraseIndex}`} speaker={speaker}
          position={position} progressPercent={progressPercent} {...event}
        />
      ));
    }

    if (redactedSections && redactedSections.length > 0) {
      allEvents.push(redactedSections.map((event, redactedSectionIndex) =>
        <RedactedSectionEvent key={`redacted-section-${eventIndex}-${redactedSectionIndex}`} speaker={speaker}
          progressPercent={progressPercent} {...event}
        />
      ));
    }

    allEvents.push([
      <SpeechEvent key={`transcript-event-${eventIndex}-${startTime}`} startTime={startTime}
        endTime={endTime} speaker={speaker} progressPercent={progressPercent}
      />
    ]);
    return allEvents;
  }, []);
};

Events.propTypes = {
  events: PropTypes.array.isRequired,
  progressPercent: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired
};

export default memo(Events);
